// authApi.js
import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const GetLastOpdRefundEntry = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-refund-entries/get-last-opd-refund-entry`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "Ipdentries fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const StoreOpdRefundEntry = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-refund-entries`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetOpdRefundEntries = async () => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-refund-entries`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "opdentries fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetOpdRefundEntryById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-refund-entries/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateOpdRefundEntry = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-refund-entries/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteOpdRefundEntry = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-refund-entries/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};